import { InvoiceTotalPriceColumns } from '../enums/invoiceTotalPriceColumns'

export const getInvoiceTotalPriceColumns = (columns: readonly string[]): InvoiceTotalPriceColumns | undefined => {
  const hasGrossTotal = columns.includes('total')
  const hasNetTotal = columns.includes('netTotal')

  if (hasGrossTotal && hasNetTotal) {
    return InvoiceTotalPriceColumns.Both
  }

  if (hasGrossTotal) {
    return InvoiceTotalPriceColumns.Gross
  }

  if (hasNetTotal) {
    return InvoiceTotalPriceColumns.Net
  }

  return undefined
}
